import { DomainError } from '../errors/domain-error';

export const GROWTH_REFERRAL_TARGET_NEWSLETTER = 'newsletter_publication';

export const GrowthReferralAttributionStatus = {
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  REJECTED: 'rejected',
} as const;

export type GrowthReferralAttributionStatusValue =
  (typeof GrowthReferralAttributionStatus)[keyof typeof GrowthReferralAttributionStatus];

export const GrowthReferralVerificationLabel = {
  CONFIRMED_SUBSCRIBER: 'confirmed_subscriber',
  SELF_REFERRAL: 'self_referral',
  REFERRER_NOT_SUBSCRIBER: 'referrer_not_subscriber',
  DUPLICATE: 'duplicate',
  PROGRAM_DISABLED: 'program_disabled',
} as const;

export type GrowthReferralVerificationLabelValue =
  (typeof GrowthReferralVerificationLabel)[keyof typeof GrowthReferralVerificationLabel];

export const GROWTH_REFERRAL_MILESTONE_MIN = 1;
export const GROWTH_REFERRAL_MILESTONE_MAX = 1000;
export const GROWTH_REFERRAL_DEFAULT_MILESTONE_COUNT = 5;
export const GROWTH_REFERRAL_DEFAULT_MILESTONE_LABEL = 'Milestone';

export function buildPublicationReferralPath(slug: string, referralCode: string): string {
  return `/n/${slug}/subscribe?ref=${encodeURIComponent(referralCode)}`;
}

export function assertPublicationReferralMilestoneCount(value: number): number {
  if (
    !Number.isInteger(value) ||
    value < GROWTH_REFERRAL_MILESTONE_MIN ||
    value > GROWTH_REFERRAL_MILESTONE_MAX
  ) {
    throw new DomainError('Milestone count must be 1–1000');
  }
  return value;
}

export function assertPublicationReferralMilestoneLabel(value: string): string {
  const trimmed = value.trim();
  if (!trimmed || trimmed.length > 80) {
    throw new DomainError('Milestone label must be 1–80 characters');
  }
  return trimmed;
}

export function canApplyPublicationReferral(params: {
  enabled: boolean;
  referrerContactId: string;
  referredContactId: string;
  referrerUserId?: string | null;
  referredUserId?: string | null;
}): boolean {
  if (!params.enabled) return false;
  if (params.referrerContactId === params.referredContactId) return false;
  if (
    params.referrerUserId &&
    params.referredUserId &&
    params.referrerUserId === params.referredUserId
  ) {
    return false;
  }
  return true;
}

export function publicationReferralVerificationLabel(params: {
  enabled: boolean;
  referrerFound: boolean;
  canApply: boolean;
}): GrowthReferralVerificationLabelValue {
  if (!params.enabled) return GrowthReferralVerificationLabel.PROGRAM_DISABLED;
  if (!params.referrerFound) return GrowthReferralVerificationLabel.REFERRER_NOT_SUBSCRIBER;
  if (!params.canApply) return GrowthReferralVerificationLabel.SELF_REFERRAL;
  return GrowthReferralVerificationLabel.CONFIRMED_SUBSCRIBER;
}
